import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import StepContent from "@material-ui/core/StepContent";
import Stepper from "@material-ui/core/Stepper";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
	root: {
		width: "90%",
		flexWrap: "wrap",
		justifyContent: "space-around",
		overflow: "visible",
	},
	button: {
		marginRight: theme.spacing(1),
	},
	completed: {
		display: "inline-block",
	},
	instructions: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
	},
}));

export default function VerticalLinearStepper(props) {
	const classes = useStyles();
	const [activeStep, setActiveStep] = React.useState(
		props.steps.length - props.currentSteps
	);
	const state = useSelector((state) => state);

	let Signatures = [];
	try {
		Signatures = props.signatureImage[0].signature;
	} catch (e) {}

	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	const handleReset = () => {
		setActiveStep(0);
	};
	function isStepComplete(step) {
		//return completed.has(step);
	}
	const handleStep = (step) => () => {
		console.log("handleStep=", step);
		setActiveStep(step);
	};

	console.log("Signature props.currentSteps=", props.currentSteps);

	useEffect(() => {
		console.log("activeStep=", activeStep);
	}, [activeStep, setActiveStep]);
	return (
		<div className={classes.root}>
			<Stepper nonLinear activeStep={activeStep} orientation="vertical">
				{props.steps.map((label, index) => (
					<Step key={label.key}>
						<StepButton
							onClick={handleStep(index)}
							completed={label.status ? true : false}
						>
							{label.title}
						</StepButton>
						<StepContent>
							<Typography>
								{label.content ? label.content : "Pending Signature"}
							</Typography>
							{Signatures.find((x) => x.office_id === label.key) && (
								<>
									<img
										src={Signatures.find((x) => x.office_id === label.key).data}
										style={{ width: 160, height: 80 }}
									/>
									<div>
										Signed By:
										{" " +
											state.auth.user.allUser.find(
												(y) =>
													y._id ===
													Signatures.find((x) => x.office_id === label.key)
														.usernameId
											).username}{" "}
										on:{" "}
										{moment(
											Signatures.find((x) => x.office_id === label.key)
												.createdate
										).format("Do,MMM yyyy")}
									</div>
								</>
							)}

							<div className={classes.actionsContainer}></div>
						</StepContent>
					</Step>
				))}
			</Stepper>
		</div>
	);
}
